import { Controller } from "@hotwired/stimulus";

// I filtri restano fuori dal frame: digitazione e focus non vengono sostituiti.
export default class extends Controller {
  search() {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.submit(), 400);
  }

  submit() {
    clearTimeout(this.timer);
    this.element.requestSubmit();
  }

  disconnect() { clearTimeout(this.timer); }
}
